import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top-border"></div>
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <h2 className="time-frame-logo">
              Shree <span className="studios-text">Photos</span>
            </h2>
          </div>

          <div className="footer-info-row">
            <div className="info-item">
              <span className="icon">📞</span>
              <span className="text">+91 9762 470 338</span>
            </div>
            <span className="info-separator">|</span>
            <div className="info-item">
              <span className="icon">✉️</span>
              <span className="text">nikhil.deshapande@gmail.com</span>
            </div>
            <span className="info-separator">|</span>
            <div className="info-item">
              <span className="icon">📍</span>
              <span className="text">Premlok Park Colony, Chinchwad, Pune 411033</span>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">© COPYRIGHT Shree Photos</p>
          <div className="footer-links">
            <a href="#">Privacy Policy</a>
            <span className="separator">|</span>
            <a href="#">T&C</a>
            <span className="separator">|</span>
            <a href="#">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;